import './ContactWidget.css';
import ZaloImage from '../assets/zalo.webp';

import React, { useState } from 'react';
import { FaPhone, FaFacebookMessenger, FaBars, FaWindowClose } from 'react-icons/fa';
import { SiZalo } from "react-icons/si";

const ContactWidget = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`contact-widget ${isOpen ? 'open' : ''}`}>
            <div className="widget-items">
                {/* Phone Button */}
                <a href="tel:0979871117" className="widget-item phone" title="Gọi điện">
                    <div className="icon-circle">
                        <FaPhone size={24} color="white" />
                    </div>
                </a>

                {/* Messenger Button */}
                <a href="https://m.me/caolip97" target="_blank" rel="noopener noreferrer" className="widget-item messenger" title="Messenger">
                    <div className="icon-circle">
                        <FaFacebookMessenger size={24} color="white" />
                    </div>
                </a>

                {/* Zalo Button */}
                <a href="https://zalo.me/0979871117" target="_blank" rel="noopener noreferrer" className="widget-item zalo" title="Zalo">
                    <div className="icon-circle">
                        <SiZalo size={24} color="white" />
                    </div>
                </a>
            </div>

            {/* Main Toggle Button */}
            <div className="widget-item menu" title="Liên hệ" onClick={() => setIsOpen(!isOpen)}>
                <div className="icon-circle main-btn">
                    {isOpen ? (
                        <FaWindowClose size={24} color="white" />
                    ) : (
                        <FaBars size={24} color="white" />
                    )}
                </div>
            </div>
        </div>
    );
};

export default ContactWidget;
